const noop = () => {
  /*do nothing*/
};
export default {
  noop,
};
